<template>
    <div>
        <div class="header py-7 py-lg-8 pt-lg-9" :class="AppStyle.GRADIENT_STYLE">
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 0" preserveAspectRatio="none" version="1.1"
                    xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>

        <!-- Page content -->
        <b-container class="mt--8 pb-5">
            <b-row class="justify-content-center">
                <b-col lg="8" md="12">
                    <b-card no-body class="border-0 mb-0">
                        <b-card-body class="px-lg-5 py-lg-5">

                            <div class="loader" v-if="loading"></div>

                            <div class="text-center text-muted mb-4">
                                <!-- img :src="logo" class="navbar-brand-img" alt="Sidebar logo" width="90%" -->
                            </div>


                            <div class="text-center text-muted mb-4">
                                <h1>Ready to Publish Your Art Book?</h1>
                                <p>Submit your application 👇</p>
                            </div>





                            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">



                                    <b-row>
                                        <b-col md="12">
                                            

                                            <b-col md="12">

                                                <label>Do you have 100+ publication-ready images?*</label>

                                                <b-form-radio-group v-model="images_ready">
                                                    <div>
                                                        <b-form-radio value="1" name="unchecked" class="mb-3">
                                                            Yes, i do
                                                        </b-form-radio>
                                                    </div>
                                                    <div>
                                                        <b-form-radio value="0" name="checked" class="mb-3">
                                                            No, not yet
                                                        </b-form-radio>
                                                    </div>
                                                </b-form-radio-group>

                                                <p v-if="showForm">*Images placed on a full A4 page (297 mm x 210 mm or 8.5 x 11 inches) need to have a minimum of 3500 pixels on
their longest side. For images placed on a full spread (A3) (420 mm x 297 mm or 17 x 11 inches), a minimum of
5500 pixels on the longest side is required.</p>
                                            </b-col>
                                        </b-col>
                                    </b-row>


                                    <b-row v-if="!showForm">
                                        <b-col md="12">
                                            
                                            <h2>We're Sorry. Keep Creating and Come Back Soon!</h2>

                                            <p>Please continue refining your portfolio. Once you have 100+ publication-ready images, we'd love to work together! Feel free to reach out then.</p>
                                        </b-col>
                                    </b-row>


                                    <b-row v-if="showForm">
                                        <b-col md="12">

                                            <label>Tell us about your book idea*</label>
                                            
                                            <base-input>
                                                <textarea class="form-control" id="exampleFormControlTextarea3" rows="3" v-model="book_idea" ></textarea>
                                            </base-input>

                                        </b-col>
                                    </b-row>

                                    <b-row v-if="showForm">

                                        <b-col md="12">

                                            <label>Artistic Category*</label>

                                            <base-input name="Country" rules="required">
                                                <el-select v-model="categrory" filterable placeholder="Category"
                                                    rules="required">
                                                    <el-option v-for="option in categories" :key="option.label"
                                                        :label="option.label" :value="option.value">
                                                    </el-option>
                                                </el-select>
                                            </base-input>
                                        </b-col>

                                    </b-row>


                                    <b-row v-if="showForm">
                                        <b-col md="12">
                                            <label>Do you currently sell your art? If so, where are your customers located?</label>


                                                <b-form-radio-group v-model="sell_art">
                                                    <div>
                                                        <b-form-radio value="1" name="unchecked" class="mb-3">
                                                            Yes, i do sell my art
                                                        </b-form-radio>
                                                    </div>
                                                    <div>
                                                        <b-form-radio value="0" name="checked" class="mb-3">
                                                            Not yet
                                                        </b-form-radio>
                                                    </div>
                                                </b-form-radio-group>

                                                <label>Where are your customers located?*</label>
                                                <base-input prepend-icon="fas fa-user" placeholder="Your Name" v-model="firstname" name="Firstname" rules="required|alpha_num"></base-input>
                                       

                                        </b-col>
                                    
                                    </b-row>

                                    <b-row v-if="showForm">

                                        <b-col md="6">
                                            <label>Your firstname*</label>
                                            <base-input prepend-icon="fas fa-user" placeholder="Your Name" v-model="firstname" name="Firstname" rules="required|alpha_num"></base-input>
                                        </b-col>

                                        <b-col md="6">
                                            <label>Your lastname*</label>
                                            <base-input prepend-icon="fas fa-user" placeholder="Your Surname" v-model="lastname" name="Lastname" rules="required|alpha_num"></base-input>
                                        </b-col>

                                    </b-row>

                                    <b-row v-if="showForm">

                                        <b-col md="12">
                                            <label>Your email*</label>
                                            <base-input prepend-icon="fas fa-envelope" placeholder="Your email" v-model="email" name="email" rules="required|alpha_num"></base-input>
                                        </b-col>

                                    </b-row>

                                    <b-row v-if="showForm">

                                        <b-col md="12">
                                            <label>Instagram handle (or website)*</label>
                                            <base-input prepend-icon="fas fa-globe" placeholder="Instagram handle (or website)" v-model="instagram" name="email" rules="required|alpha_num"></base-input>
                                        </b-col>

                                    </b-row>


                                    <b-row v-if="showForm">
                                        
                                        <b-col md="12">
                                            <label>Please share some images for your book idea with us*</label>
                                            <dropzone-file-upload v-model="inputs.fileMultiple" multiple
                                        :options="sample_art_dz.options"
                                        :url="sample_art_dz.url" 
                                        v-on:complete="dz_complete" 
                                        v-on:success="dz_success" 
                                        v-on:addedfile="dz_added" 
                                        v-on:error="dz_error" 
                                        v-on:queuecomplete="dz_queuecomplete"
                                    ></dropzone-file-upload>
                                    <p>Upload 3 images for your book idea. This helps us get a feel for your art.</p>
                                        </b-col>

                                    </b-row>



                                    <b-row v-if="showForm">
                                        <b-col md="12">
                                            

                                            <label>You will be responsible for investing your time into this project and ask for help from your community to sell at
least 25 books within two weeks for a price of 119 Euro. Do you feel comfortable taking care of the marketing of your book?</label>


                                                <b-form-radio-group v-model="comfort_sell_art">
                                                    <div>
                                                        <b-form-radio value="1" name="unchecked" class="mb-3">
                                                            Yes
                                                        </b-form-radio>
                                                    </div>
                                                    <div>
                                                        <b-form-radio value="0" name="checked" class="mb-3">
                                                            No
                                                        </b-form-radio>
                                                    </div>
                                                </b-form-radio-group>

                                                
                                                <label>Where are your customers located?*</label>
                                                <base-input prepend-icon="fas fa-user" placeholder="Your Name" v-model="firstname" name="Firstname" rules="required|alpha_num"></base-input>
                         
                                        </b-col>
                                    
                                    </b-row>


                                    
                                    <div class="text-center" v-if="showForm">
                                        <base-button :type="AppStyle.BUTTON_STYLE_S" native-type="submit"
                                            class="my-4">Submit</base-button>
                                    </div>

                                </b-form>
                            </validation-observer>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppStyle from '@/plugins/appStyle';
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import { configure } from 'vee-validate';
import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
import DzListGroupItem from '../cscomponents/elements/DzListGroupItem';


export default {
    mixins: [AppStyle.Mixin],
    name: 'SnapRegistration',
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        DropzoneFileUpload,
        DzListGroupItem,
    },
    data() {
        return {
            loading: false,
            showForm: false,

            images_ready: false,
            sell_art: '',
            comfort_sell_art: '',
            firstname: '',
            lastname: '',
            email: '',
            instagram: '',
            website: '',
            categrory: '',
            book_idea: '',
            document: [],
            expired: false,
            categories: [
                { value: "Architectural", label: "Architectural" },
                { value: "Fashion", label: "Fashion" },
                { value: "Fine Art", label: "Fine Art" },
                { value: "Landscape", label: "Landscape" },
                { value: "Nude", label: "Nude" },
                { value: "Portrait", label: "Portrait" },
                { value: "Street", label: "Street" },
                { value: "Wildlife", label: "Wildlife" },
                { value: "Other", label: "Other" },
            ],
            sample_art_dz: {
                options: {
                    type: Object,
                    autoProcessQueue: true,
                    uploadMultiple: false,
                    parallelUploads: 1,
                    addRemoveLinks: false,
                    acceptedFiles: 'image/*,application/pdf',
                    maxFiles: 10,
                    maxFilesize: 1000,
                    disablePreviews: true,
                    timeout: 1800000,
                    paramName: "[photo_book][photo_book_images][temp_image]",
                    params: {
                        '[photo_book][photo_book_images][imagetype]': 'interiorreq',
                    },
                },
                url: '',
            },
            ims: [],
            inputs: {
                fileSingle: [],
                fileMultiple: []
            },
        };
    },
    props: {
        logo: {
            type: String,
            default: AppStyle.LOGO,
            description: 'Sidebar app logo'
        },
        slug: {
            type: String,
        },
    },
    mounted() {
        // this.retrieveRegistrationData();
        //this.checkCurrentLogin()
        this.sample_art_dz.url = this.dzUrl();
    },
    updated() {
        //this.checkCurrentLogin()
    },
    methods: {
        onSubmit() {
            console.log("SUBMIT NOW ---_> OnSubmit");
            this.registerAndPublish();
            // this.$api.login(this.model.email, this.model.password).then(request => this.loginSuccessful(request)).catch(() => this.loginFailed())
        },
        handleSubmit() {
            // check if all is there
            console.log("SUBMIT NOW");
        },
        registerAndPublish() {
            this.loading = true;
            this.$api.setRegistrationData(this.account, this.acctok, this.projtok, this.confirmcontract)
                .then((response) => {
                    console.log(response);
                    // hiernach redirect falls erfolgreich... und nutzer einloggen
                    if (response.data.token) {
                        // we have token redirect
                        localStorage.token = response.data.token; //req.data.token
                        this.$store.dispatch('login')
                        this.$router.replace(this.$route.query.redirect || '/portal');
                    }
                    else {
                        // error...hmmm what now?
                    }
                    // this.account = response.data;
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });



        },

        retrieveDocument() {
            this.loading = true;
            this.$api.getDocument("publishing_contract")
                .then((response) => {
                    this.document = response.data;
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    this.retrieveDocumentFile();
                });
        },

        formatDate(date) {
            return moment(date).format("Do MMM YYYY")
        },


        dzUrl(){
            return this.$image_host + '/api/v1/spa/photo_books/' + this.currentPhotoBook.id + '/photo_book_image';
        },
        buildUrl(image){
            console.log(image)
            let ht = this.$image_host+image.image.medium.url;
            return ht
        },
        dz_added(data){
            console.log("ADDED"+data);
        },
        // dropzone part
        dz_complete(data){
            this.allDataValidated();
        },
        dz_success(data){
            console.log(data.xhr.response);
            this.currentPhotoBookImages.push(JSON.parse(data.xhr.response));
            this.allDataValidated();
        },
        dz_error(data){
            swal.fire({
                title: 'Please check requirements:',
                text: this.build_error_text(data.xhr.response),
                timer: 5000,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-warning',
                icon: 'warning'
            });
        },
        dz_queuecomplete(data){
            console.log("QUEUECOMPLETE");
            //console.log(data);
        },

    },
    watch: {

        images_ready(newValue, oldValue) {
        console.log('queryParameter imageId changed from: ' + oldValue + ' -> ' + newValue);
        //this.fetchCover();
        //this.fetchDesigner();
        // this.fetchComments();
        // redirect if needed -> dashboard
        if(this.images_ready == 1){
            this.showForm = true;
            return true;
        }
        else{
            this.showForm = false;
            return false;
        }
        },
    },
}
</script>

<style>
        .dropzone {
            border: dashed 4px #ddd !important ;
            background-color: #f2f6fc;
            border-radius: 15px;
        }
    
        .dropzone .dropzone-container {
            padding: 2rem 0;
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #8c96a8;
            z-index: 20;
        }
    
        .dropzone .file-input {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            visibility: hidden;
            cursor: pointer;
        }

        .file-icon{
            font-size: 60px;
        }
        .hr-sect {
            display: flex;
            flex-basis: 100%;
            align-items: center;
            margin: 8px 0px;
        }
        .hr-sect:before,
        .hr-sect:after {
            content: "";
            flex-grow: 1;
            background: #ddd;
            height: 1px;
            font-size: 0px;
            line-height: 0px;
            margin: 0px 8px;
        }
    </style>
    